import { useCompanyDateTime, useSettings } from '@innovyze/stylovyze';
import { DateTimePicker } from '@mui/x-date-pickers-pro';
import { offsetDateTime } from '@Utils/offsetDateTime';
import { DateTime } from 'luxon';
import React from 'react';

interface ResampleModalProps {
	value: DateTime;
	setValue: (timestamp: DateTime) => void;
	isValid: boolean;
	errorMessages: { invalid: string };
	dataCy?: string;
	label: string;
	name: string;
}

export default function ResampleDialogDatePicker({
	value,
	setValue,
	isValid,
	errorMessages,
	dataCy,
	label,
	name,
}: ResampleModalProps) {
	const { companySettings } = useSettings();
	const { dateFormat, timeFormat } = useCompanyDateTime();

	const handleOnChange = (date: DateTime | null) => {
		if (!date) return;
		setValue(offsetDateTime(date, companySettings.timeZoneIANA));
	};

	return (
		<DateTimePicker
			name={name}
			value={value}
			label={`${label} [${companySettings.timeZoneIANA}]`}
			format={`${dateFormat} ${timeFormat}`}
			onChange={handleOnChange}
			data-cy={dataCy}
			ampm={!!companySettings.hourCycle12}
			ampmInClock={!!companySettings.hourCycle12}
			timezone={companySettings.timeZoneIANA}
			slotProps={{
				textField: {
					name: name,
					helperText: !isValid ? errorMessages.invalid : '',
					variant: 'outlined',
					error: !isValid,
					color: 'secondary',
					fullWidth: true,
				},
			}}
		/>
	);
}
